import { HexMapResourceType, HexMapResourceTypeID } from "./hexmap";
export const RESOURCE_TYPES = {
    [HexMapResourceTypeID]: HexMapResourceType,
};
export * from './hexmap';
//# sourceMappingURL=index.js.map